<div class="container" [class.containerMobile]="isMobile">
  <div class="typeWrapper">
    <span>{{ 'total_sum' | translate }}: <span class="value" data-ctx="label-total-pallet-count">{{ workSpacesLength }}</span></span>
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'loaded-loads'" class="elementIcon"></gl-icon>
    </div>
    <div class="valueWrapper" [glTooltip]="'loaded_loads'" [position]="'top'">
      <span class="value-description"> {{ 'loaded_loads_acronym' | translate }}: </span>
      @if (workSpacesSummary) {
        <span class="value">
          {{ workSpacesSummary.loadedLoads }}
        </span>
      }
    </div>
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'loads-not-fit'" class="elementIcon"></gl-icon>
    </div>
    <div class="valueWrapper" [glTooltip]="'not_loaded_loads'" [position]="'top'">
      <span class="value-description"> {{ 'not_loaded_loads_acronym' | translate }}: </span>
      <span class="value">
        @if (workSpacesSummary && workSpacesSummary.notLoadedLoads > 0) {
          <span>{{
            workSpacesSummary.notLoadedLoads
          }}</span>
        }
        @if (!(workSpacesSummary?.notLoadedLoads > 0)) {
          <span>-</span>
        }
      </span>
    </div>
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'weight-total'" class="elementIcon"></gl-icon>
    </div>
    @if (!isTotalWeightOverLimit()) {
      <div
        class="valueWrapper"
        [glTooltip]="'sum_of_loads_weight'"
        [position]="'top'"
        >
        <span class="value-description"> {{ 'sum_of_loads_weight_acronym' | translate }}: </span>
        @if (workSpacesSummary) {
          <span class="value">
            {{ workSpacesSummary.totalWeight | unit: 'weight':false }}
          </span>
        }
      </div>
    }

    @if (isTotalWeightOverLimit()) {
      <div
        #weightError
        [glTooltip]="'error_weight_over_limit'"
        [isError]="true"
        [position]="'top'"
        class="valueWrapper error"
        >
        <span class="value-description"> {{ 'sum_of_loads_weight_acronym' | translate }}: </span>
        <span class="value">
          {{ workSpacesSummary.totalWeight | unit: 'weight':false }}
        </span>
      </div>
    }
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'space'" class="elementIcon"></gl-icon>
    </div>
    <div class="valueWrapper" [glTooltip]="'free_space'" [position]="'top'">
      <span class="value-description"> {{ 'free_space_acronym' | translate }}: </span>
      @if (workSpacesSummary) {
        <span class="value">
          {{ workSpacesSummary.freeArea }} {{
          getAreaAndVolumeUnit()
          }}<span class="superscript">2</span>
        </span>
      }
    </div>
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'used-volume'" class="elementIcon"></gl-icon>
    </div>
    <div class="valueWrapper" [glTooltip]="'loads_summary_volume'" [position]="'top'">
      <span class="value-description"> {{ 'loads_volume_acronym' | translate }}: </span>
      @if (workSpacesSummary) {
        <span class="value">
          {{ workSpacesSummary.occupiedVolume }}/{{ workSpacesSummary.totalVolume }}
          {{ getAreaAndVolumeUnit() }}<span class="superscript">3</span>
        </span>
      }
    </div>
  </div>

  @if (showLdm()) {
  <div class="ldmWrapper" [glTooltip]="totalLDMTooltip()">
    <div class="valueWrapper">
      <span class="value-description"> {{ 'ldm_taken' | translate }}: </span>
      @if (workSpacesSummary) {
        <span class="value">
          {{ workSpacesSummary.takenLdm }}
        </span>
      }
    </div>
    <div
      class="ldm-line"
      [style.background]="
          'linear-gradient(90deg, #1CB9FC ' +
          calculateLineWidthPercentage() +
          '%' +
          ', #67FCAC ' +
          calculateLineWidthPercentage(5) +
          '%' +
          ')'
        "
    ></div>
    <div class="valueWrapper">
      <span class="value-description"> {{ 'ldm_free' | translate }}: </span>
      @if (workSpacesSummary) {
        <span class="value">
          {{ workSpacesSummary.freeLdm }}
        </span>
      }
    </div>
  </div>
  }
</div>
